<template>
  <div id="chart-board-box">
    <div class="chart-title">
      <img class="charts-icon" :src="require('@/assets/images/largescreen/charts-icon.png')" alt="">
      <dv-decoration-1 />
      <span>{{ areaName === 'china' ? '全国' : areaName }}</span>
    </div>
    
    <!-- ✅ 重构：使用 Grid 布局替代 el-row/el-col -->
    <div class="overview-grid">
      <!-- 装机统计卡片 -->
      <article class="stat-card stat-card--install">
        <div class="card-icon">🖥️</div>
        <div class="card-content">
          <div class="card-label">装机</div>
          <div class="card-value current">
            <span class="value-label">当月:</span>
            <span class="value-num">{{ overviewData.currentMonthInstalled }}</span>
            <span class="value-unit">台</span>
          </div>
          <div class="card-value ytd">
            <span class="value-label">YTD:</span>
            <span class="value-num">{{ overviewData.installedYTD }}</span>
            <span class="value-unit">台</span>
          </div>
        </div>
      </article>

      <!-- 回款统计卡片 -->
      <article class="stat-card stat-card--repayment">
        <div class="card-icon">💰</div>
        <div class="card-content">
          <div class="card-label">回款</div>
          <div class="card-value current">
            <span class="value-label">当月:</span>
            <span class="value-num">{{ overviewData.currentMonthRepayment }}</span>
            <span class="value-unit">%</span>
          </div>
          <div class="card-value ytd">
            <span class="value-label">YTD:</span>
            <span class="value-num">{{ overviewData.repaymentYTD }}</span>
            <span class="value-unit">%</span>
          </div>
        </div>
      </article>

      <!-- 使用统计卡片 -->
      <article class="stat-card stat-card--usage">
        <div class="card-icon">👥</div>
        <div class="card-content">
          <div class="card-label">使用</div>
          <div class="card-value current">
            <span class="value-label">当月:</span>
            <span class="value-num">{{ overviewData.currentMonthUse }}</span>
            <span class="value-unit">人次</span>
          </div>
          <div class="card-value ytd">
            <span class="value-label">YTD:</span>
            <span class="value-num">{{ overviewData.useYTD }}</span>
            <span class="value-unit">人次</span>
          </div>
        </div>
      </article>

      <!-- 质控统计卡片 -->
      <article class="stat-card stat-card--quality">
        <div class="card-icon">✅</div>
        <div class="card-content">
          <div class="card-label">质控</div>
          <div class="card-value current">
            <span class="value-label">应质控:</span>
            <span class="value-num">{{ overviewData.shouldBeQualityControl }}</span>
            <span class="value-unit">家</span>
          </div>
          <div class="card-value ytd">
            <span class="value-label">已质控:</span>
            <span class="value-num">{{ overviewData.alreadyQualityControl }}</span>
            <span class="value-unit">家</span>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import resize from '@/utils/resize'
import echarts from "echarts";

export default {
  mixins: [resize],
  name: "bodyCenterBottom",
  props: {
    areaName: {
      type: String,
      default() {
        return ''
      }
    },
    // 测试
    overview: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      // ✅ 优化：删除了 timerId，因为 initChart 是空的，且 initTimerId 逻辑无意义
      // timerId: null, 
      overviewData: {
        currentMonthInstalled: 0, // 当月装机量
        installedYTD: 0, // 本年装机量
        currentMonthRepayment: 0, // 当月回款
        repaymentYTD: 0, // YTD回款
        currentMonthUse: 0, // 当月使用量
        useYTD: 0, // YTD使用量
        shouldBeQualityControl: 0, // 应质控
        alreadyQualityControl: 0, // 已质控
      },
    }
  },
  created() {
  },
  beforeDestroy() {
    // 移除监听器
    window.removeEventListener('orientationchange', this.handleOrientationChange)
  },
  mounted() {
    this.$nextTick(() => {
      // this.initChart() // ✅ 优化：删除了空函数的调用
      // this.initTimerId() // ✅ 优化：删除了无效定时器的初始化
    })

    // 监听屏幕方向变化
    window.addEventListener('orientationchange', this.handleOrientationChange)
  },

  watch: {
    overview: {
      handler(val) {
        // console.log('complaintOverview----->', val)
        this.overviewData = val
      },
      deep: true
    },
  },
  methods: {
    handleOrientationChange() {
      // 屏幕方向变化后，延迟重新渲染
      setTimeout(() => {
        // bodyCenterBottom 没有 ECharts 图表，不需要 resize
      }, 300)
    },
    // ✅ 优化：删除了空的 initChart 和无效的 initTimerId
    // initChart() {
    //
    // },
    // initTimerId() {
    //   setTimeout(() => {
    //     if (this.timerId) {
    //       clearInterval(this.timerId)
    //     }
    //     this.timerId = setInterval(() => {
    //       //用setInterval做动画感觉有问题
    //       try {
    //         this.initChart()
    //       } catch (e) {
    //         clearInterval(this.timerId)
    //       }
    //     }, 100);
    //   }, 500);
    // },
  }
}
</script>

<style lang="scss" scoped>
#chart-board-box {
  background: rgba(10, 57, 130, .6);
  height: 33.4%;
  color: #fff;
  display: flex;
  flex-direction: column;

  .chart-title {
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: bolder;
    padding: 8px 15px;
    background: rgba(10, 57, 130, .6);
    position: relative;
    flex-shrink: 0;

    .charts-icon {
      width: 20px;
      height: 25px;
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    .dv-decoration-1 {
      width: 60px;
      height: 20px;
      margin-left: 40px;
    }

    span {
      margin-left: 10px;
      font-size: 16px;
    }
  }

  // ✅ 重构：Grid 布局容器
  .overview-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 10px;
    padding: 10px;
    height: calc(100% - 45px); // 减去标题高度
    box-sizing: border-box;

    // ✅ 统计卡片通用样式
    .stat-card {
      background: linear-gradient(135deg, rgba(20, 80, 160, 0.4) 0%, rgba(10, 57, 130, 0.6) 100%);
      border-radius: 8px;
      padding: 12px;
      display: flex;
      align-items: center;
      gap: 12px;
      transition: all 0.3s ease;
      border: 1px solid rgba(5, 231, 207, 0.2);
      overflow: hidden;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(5, 231, 207, 0.3);
        border-color: rgba(5, 231, 207, 0.5);
      }

      // 图标区域
      .card-icon {
        font-size: 32px;
        flex-shrink: 0;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(5, 231, 207, 0.1);
        border-radius: 8px;
      }

      // 内容区域
      .card-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-width: 0; // 防止内容溢出

        .card-label {
          font-size: 18px;
          color: rgba(255, 255, 255, 0.9);
          font-weight: 600;
        }

        .card-value {
          display: flex;
          align-items: baseline;
          gap: 4px;

          &.current {
            .value-num {
              color: #05E7CF;
            }
          }

          &.ytd {
            .value-num {
              color: #FFD700;
            }
          }

          .value-label {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.6);
            flex-shrink: 0;
          }

          .value-num {
            font-size: 20px;
            font-weight: bold;
            line-height: 1;
          }

          .value-unit {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.7);
            flex-shrink: 0;
          }
        }
      }
    }

    // 不同类型卡片的边框颜色
    .stat-card--install {
      border-color: rgba(5, 231, 207, 0.3);
    }

    .stat-card--repayment {
      border-color: rgba(255, 215, 0, 0.3);
    }

    .stat-card--usage {
      border-color: rgba(255, 105, 180, 0.3);
    }

    .stat-card--quality {
      border-color: rgba(50, 205, 50, 0.3);
    }
  }
}

// 平板端适配
@media screen and (min-width: 769px) and (max-width: 1024px) {
  #chart-board-box {
    .overview-grid {
      gap: 8px;
      padding: 8px;

      .stat-card {
        padding: 10px;

        .card-icon {
          font-size: 28px;
          width: 45px;
          height: 45px;
        }

        .card-content {
          .card-label {
            font-size: 13px;
          }

          .card-value {
            .value-label {
              font-size: 11px;
            }

            .value-num {
              font-size: 18px;
            }

            .value-unit {
              font-size: 11px;
            }
          }
        }
      }
    }
  }
}

// 手机横屏特殊处理
@media screen and (orientation: landscape) and (max-height: 768px) {
  #chart-board-box {
    height: calc((100% - 30px) / 3) !important;
    min-height: unset !important;
    max-height: unset !important;
    margin-bottom: 0 !important;
    overflow: hidden !important;

    .chart-title {
      padding: 6px 12px !important;

      .charts-icon {
        width: 18px !important;
        height: 22px !important;
      }

      .dv-decoration-1 {
        width: 50px !important;
        height: 18px !important;
      }

      span {
        font-size: 14px !important;
      }
    }

    .overview-grid {
      gap: 8px !important;
      padding: 8px !important;
      height: calc(100% - 38px) !important;

      .stat-card {
        padding: 8px !important;
        gap: 8px !important;

        .card-icon {
          font-size: 24px !important;
          width: 40px !important;
          height: 40px !important;
        }

        .card-content {
          gap: 4px !important;

          .card-label {
            font-size: 12px !important;
          }

          .card-value {
            .value-label {
              font-size: 10px !important;
            }

            .value-num {
              font-size: 16px !important;
            }

            .value-unit {
              font-size: 10px !important;
            }
          }
        }
      }
    }
  }
}

// 手机竖屏适配
@media screen and (max-width: 768px) and (orientation: portrait) {
  #chart-board-box {
    height: auto !important;
    min-height: 350px;
    margin-bottom: 10px;

    .chart-title {
      padding: 8px 10px !important;

      span {
        font-size: 13px !important;
        margin-left: 35px !important;
      }

      .charts-icon {
        width: 16px !important;
        height: 20px !important;
        left: 10px !important;
      }

      .dv-decoration-1 {
        width: 40px !important;
        height: 15px !important;
      }
    }

    .overview-grid {
      grid-template-columns: 1fr !important; // 单列布局
      grid-template-rows: repeat(4, auto) !important;
      gap: 8px !important;
      padding: 8px !important;
      height: auto !important;
      min-height: 280px;

      .stat-card {
        padding: 10px !important;

        .card-icon {
          font-size: 28px !important;
          width: 45px !important;
          height: 45px !important;
        }

        .card-content {
          .card-label {
            font-size: 13px !important;
          }

          .card-value {
            .value-label {
              font-size: 11px !important;
            }

            .value-num {
              font-size: 18px !important;
            }

            .value-unit {
              font-size: 11px !important;
            }
          }
        }
      }
    }
  }
}

// ✅ 1080p 屏幕专属优化
@media screen and (min-width: 1920px) and (max-width: 2560px) and (min-height: 1080px) and (max-height: 1440px) {
  #chart-board-box {
    .chart-title {
      span {
        font-size: 20px !important; // ✅ 增大标题字体
      }
      
      .charts-icon {
        width: 24px !important;
        height: 30px !important;
      }
      
      .dv-decoration-1 {
        width: 70px !important;
        height: 24px !important;
      }
    }
    
    .overview-grid {
      gap: 12px !important;
      padding: 12px !important;
      
      .stat-card {
        padding: 14px !important;
        
        .card-icon {
          font-size: 36px !important;
          width: 56px !important;
          height: 56px !important;
        }
        
        .card-content {
          .card-label {
            font-size: 20px !important; // ✅ 增大卡片标签
          }
          
          .card-value {
            .value-label {
              font-size: 14px !important;
            }
            
            .value-num {
              font-size: 24px !important; // ✅ 增大数值
            }
            
            .value-unit {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
}
</style>
